<template>
  <b-form-group
    label="Notlar"
    label-for="notes"
  >
    <b-form-textarea
      id="notes"
      v-model="dataItem.notes"
      placeholder="Notlar"
      rows="3"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'NotesText',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
}
</script>
